"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClearIndicator = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_icon_1 = require("@hopin-team/ui-icon");

var react_1 = tslib_1.__importDefault(require("react"));

var react_select_1 = require("react-select");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

var StyledClearIndicator = (0, styled_components_1.default)(react_select_1.components.ClearIndicator)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n\n  &:hover {\n    ", "\n  }\n"], ["\n  color: ", ";\n\n  &:hover {\n    ", "\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["600"]', theme);
}, function (_a) {
  var isFocused = _a.isFocused,
      theme = _a.theme;
  return isFocused ? (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["800"]', theme) : (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.GREY["600"]', theme);
});

function createClearIndicator(_a) {
  var title = _a.title,
      description = _a.description;
  return function ClearIndicator(props) {
    return react_1.default.createElement(StyledClearIndicator, tslib_1.__assign({}, props), react_1.default.createElement(ui_icon_1.Icon, {
      description: description,
      isParentColor: true,
      name: "close",
      title: title,
      scale: 1.5
    }));
  };
}

exports.createClearIndicator = createClearIndicator;
var templateObject_1;